import { render, staticRenderFns } from "./SelectSection.vue?vue&type=template&id=0610b22b"
import script from "./SelectSection.vue?vue&type=script&lang=js"
export * from "./SelectSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports